// extracted by mini-css-extract-plugin
module.exports = {"comp":"EarlyBird_comp__dAMv2"};